<script>
import axios from 'axios'
import moment from 'moment/moment'
import { mapGetters, mapState } from 'vuex'
import AutomationRequestBotDetail from '@/components/self-service/AutomationRequestBotDetail.vue'
const _ = require('lodash')
export default {
  name: 'AutomationRequestBots',
  components: {
    AutomationRequestBotDetail
  },
  computed: {
    moment() {
      return moment
    },
    ...mapGetters({
      can: 'can'
    })
  },

  props: {
    execution: {
      type: Object,
      required: true
    },
    selectedExecutionId: {
      type: String,
      required: false,
      default: null
    }
  },
  watch: {
    pagination: {
      handler() {
        try {
          if (
            this.pagination.page !== this.current.page ||
            this.pagination.rowsPerPage !== this.current.rowsPerPage ||
            this.pagination.sortBy !== this.current.sortBy ||
            this.pagination.descending !== this.current.descending
          ) {
            this.current.page = this.pagination.page
            this.current.rowsPerPage = this.pagination.rowsPerPage
            this.current.sortBy = this.pagination.sortBy
            this.current.descending = this.pagination.descending
            this.getItems()
          }
          // eslint-disable-next-line no-empty
        } catch (error) {}
      },
      deep: true
    },
    selectedExecutionId() {
      this.getItems()
    }
  },
  data: () => ({
    showId: false,
    headerBots: [
      {
        text: 'Execution Type / Mode',
        value: 'executionType',
        sortable: false
      },
      { text: 'Name / Description', value: 'name', sortable: false },
      // { text: 'Description', value: 'descriptionItem' },
      { text: 'Run Status', value: 'runStatus', sortable: false },
      { text: 'Started At', value: 'createdAt' },
      { text: 'Completed At', value: 'completedAt', sortable: false }
    ],
    headerBotsWithId: [
      {
        text: 'Execution ID / External ID',
        align: 'left',
        value: 'hexId'
      },
      {
        text: 'Execution Type / Mode',
        value: 'executionType',
        sortable: false
      },
      { text: 'Name / Description', value: 'name', sortable: false },
      // { text: 'Description', value: 'descriptionItem' },
      { text: 'Run Status', value: 'runStatus', sortable: false },
      { text: 'Started At', value: 'createdAt' },
      { text: 'Completed At', value: 'completedAt', sortable: false }
    ],
    executions: [],
    executionsLoading: false,
    searchExecutions: '',
    pagination: {
      page: 1,
      rowsPerPage: 5,
      sortBy: 'createdAt',
      descending: false,
      totalItems: 0
    },
    current: {
      page: 1,
      rowsPerPage: 5,
      sortBy: 'createdAt',
      descending: false
    },
    rowsPerPageItems: [5, 10, 25]
  }),

  mounted() {
    this.getItems()
  },
  methods: {
    focusCurrentExecution(item) {
      this.$router.push({ name: 'execution', params: { hexId: item.hexId } })
    },

    format(input) {
      return _.capitalize(_.startCase(input))
    },
    getLocalTime(input) {
      return moment(input)
        .utc()
        .local()
        .format('DD MMM YYYY, hh:mm:ss a')
    },
    getUrlParams() {
      let urlParams = ''
      //fill URL Params from current structure

      urlParams += `&page=${this.current.page}`
      urlParams += `&size=${this.current.rowsPerPage}`
      if (this.current.sortBy) {
        urlParams += `&sort=${this.current.sortBy}`
        if (this.current.descending) {
          urlParams += `,desc`
        }
      }
      if (this.searchExecutions) {
        //search hexId from bot store based on name and description if it contains searchExecutions
        let botHexIds = this.bots
          .filter(
            bot =>
              bot.name
                .toLowerCase()
                .includes(this.searchExecutions.toLowerCase()) ||
              bot.description
                .toLowerCase()
                .includes(this.searchExecutions.toLowerCase())
          )
          .map(bot => bot.hexId)
        if (botHexIds.length > 0) {
          urlParams += `&bot=${botHexIds.join(',')}`
        }
      }
      return urlParams
    },
    clearAllFilters() {
      this.searchExecutions = ''
      this.$emit('clearAllSelections')
    },
    getItems() {
      this.executionsLoading = true
      let url = ''
      if (this.selectedExecutionId) {
        url = `/api/v1/executions/${this.selectedExecutionId}?projection=withReferenceHexId`
      } else {
        const urlParams = this.getUrlParams()
        url = `/api/v1/states/${this.execution.state}/executions/standalone?projection=withReferenceHexId${urlParams}`
      }
      axios
        .get(url)
        .then(response => {
          if (response.data._embedded) {
            this.pagination.totalItems = response.data.page.totalElements

            this.executions = response.data._embedded.executions
            this.executionsLoading = false
          } else {
            this.pagination.totalItems = 1
            let data = response.data
            this.executions = []
            this.executions.push(data)
            this.executionsLoading = false
          }
        })
        .catch(error => {
          console.log(error)
          this.executionsLoading = false
        })
    }
  }
}
</script>

<template>
  <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
    <v-card-title>
      <span class="body-1 beez-bold pl-3">Bot Executions</span>
      <v-spacer />
      <v-list-tile-avatar>
        <v-icon>search</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-sub-title>
          <v-text-field
            v-model="searchExecutions"
            color="secondary"
            label="Search by Bot Name or Description"
            xs5
          >
          </v-text-field>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="searchExecutions = ''">
          <v-icon>clear</v-icon>
        </v-btn>
        <span>Clear search</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="getItems()">
          <v-icon>cached</v-icon>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>
      <v-btn class="text-capitalize" flat outline @click.stop="showId = !showId"
        >{{ showId ? 'Hide Execution ID' : 'Show Execution ID' }}
      </v-btn>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="clearAllFilters()">
          <v-icon>clear_all</v-icon>
        </v-btn>
        <span>Clear Selections</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="showId ? headerBotsWithId : headerBots"
        :items="executions"
        :loading="executionsLoading"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="pagination.totalItems"
        item-key="hexId"
      >
        <v-progress-linear slot="progress" color="accent" indeterminate />
        <template slot="items" slot-scope="props">
          <tr>
            <td
              class="text-xs-left"
              v-if="showId"
              @click="props.expanded = !props.expanded"
            >
              <div>
                <div class="font-weight-bold">
                  {{ props.item.hexId }}
                </div>
                <br />
                <div>
                  {{ props.item.externalId }}
                </div>
              </div>
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div class="body-1 font-weight-bold">
                {{ format(props.item.executionType) }}
              </div>
              <div class="caption">
                {{ format(props.item.executedAs) }}
              </div>
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div class="body-1 font-weight-bold">
                {{
                  props.item.executionType === 'BOT'
                    ? props.item.botName
                    : props.item.workflowName
                }}
              </div>
              <div class="caption">
                {{
                  props.item.executionType === 'BOT'
                    ? props.item.botDescription
                    : props.item.workflowDescription
                }}
              </div>
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div
                :class="
                  props.item.runStatus === 'FAILED'
                    ? 'red--text'
                    : props.item.runStatus === 'OBSOLETE'
                    ? 'grey--text'
                    : 'green--text'
                "
              >
                <div class="body-1 font-weight-bold">
                  {{ format(props.item.runStatus) }}
                </div>
              </div>
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              {{ getLocalTime(props.item.createdAt) }}
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div v-if="props.item.completedAt">
                {{ getLocalTime(props.item.completedAt) }}
              </div>
            </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-flex>
            <template>
              <v-flex xs12>
                <automation-request-bot-detail
                  class="pa-2"
                  :execution-input="props.item"
                />
              </v-flex>
            </template>
          </v-flex>
        </template>
        <template slot="no-data">
          <v-alert :value="true" color="warning" icon="warning">
            No Bot executions found!
          </v-alert>
        </template>
        <template slot="no-results">
          <v-alert :value="true" color="warning" icon="warning">
            Your search for "{{ searchExecutions }}" not found.
          </v-alert>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
